var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-flex',{attrs:{"w":"100%","h":"100%","justify":"center","align":"center"}},[_c('c-spinner',{attrs:{"speed":"0.65s","empty-color":"white","color":"palettes.gold","thickness":_vm.thickness || '4px',"size":_vm.size || 'xl'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }